export enum ManualPaymentBannerType {
  None = "None",
  Upcoming = "Upcoming",
  Arrears = "Arrears",
  UpcomingAndArrears = "UpcomingAndArrears"
}
